import { TOfferCalculatorState } from '../types/redux';

export const selectRegionOptions = (state: TOfferCalculatorState) => state.calculator.regionsOptions;
